import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MontantAnnuel } from '../models/MontantAnnuel';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-montant-annuel',
  templateUrl: './montant-annuel.component.html'
})
export class MontantAnnuelComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'MontantAnnuel';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() montantAnnuel: MontantAnnuel;

  public step5 = new Step5();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
